import * as yup from 'yup';

import { ERROR_MESSAGES } from '../sign-up/sign-up.constants';
import { passwordPolicies } from '../auth-service';
import { fullNameSchema, phoneSchema, employeePositionSchema } from '../auth.validation';

const regexMap = {
    RequireNumbers: '(?=.*\\d)',
    RequireLowercase: '(?=.*[a-z])',
    RequireUppercase: '(?=.*[A-Z])',
    RequireSymbols: '(?=.*[^$*.[]{}()?-“!@#%&/,><’:;|_~`])',
};

export const userProfileSchema = async () => {
    const policy = await passwordPolicies();
    const regex = Object
        .entries(regexMap)
        .filter(([key]) => !!policy[key])
        .map(([, value]) => value)
        .join('');
    return yup.object()
        .shape({
            password: yup
                .string()
                .test('password', ERROR_MESSAGES.INVALID_PASSWORD, password => new RegExp(regex).test(password))
                .min(policy.MinimumLength, ERROR_MESSAGES.INVALID_PASSWORD_LENGTH)
                .required(ERROR_MESSAGES.REQUIRED_PASSWORD),
            name: fullNameSchema,
            employeePosition: employeePositionSchema,
            phone: phoneSchema,
        });
};
